import React, { Component } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/styles";
import { connect } from "react-redux";
import { I18n } from "@aws-amplify/core";
import { Link } from "react-router-dom";
import { get, size } from "lodash";
import Dialog from "@material-ui/core/Dialog";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Tooltip from "@material-ui/core/Tooltip";
import CircularProgress from "@material-ui/core/CircularProgress";
import MessageDialog from "../../Common/MessageDialog";

import Timer from "../../Common/Timer";
import CustomButton from "../../Common/CustomButton";
import { ReactComponent as OverrideIcon } from "../../../assets/img/common/live_override_icon.svg";
import CountDown from "../../Common/CountDown";
import Picture from "../../Common/Picture";
import TagColor from "../../Common/TagColor";
import DetectionDetails from "../DetectionDetails";
import DetectionDetailsNew from "../DetectionDetailsNew";
import CloseIcon from "../../Common/CloseIcon";
import { getLov } from "../../../utils/lov";
import { formatDate } from "../../../utils/date";
import { getTextColor } from "../../../utils/color";
import { getAttributeValue, getAttributeValues } from "../../../utils/profile";
import LiveCardAction from "./LiveCardAction";
import { walkInOut } from "../../../constants/reducers";
import FrResults from "./FrResults";
import {
  absent,
  identified,
  driver,
  truck,
  trailer,
  container,
  CONTEXT,
} from "../../../constants/common";

import { ENV, TFI } from "../../../client-config";

import colors from "../../../assets/style/colors";
import images from "../../../assets/img/images";
import ChangeDecisionDialog from "../../Common/ChangeDecisionDialog";
import { updateOneLog } from "../../../actions/siteEntranceExit/tabs";
import CorrectConfirmValue from "../CorrectConfirmValue/CorrectConfirmValue";
import { getOcrLprConfirmationCorrection } from "../../../utils/event";
import FormSection from "../../Common/FormSection";
import { fetchPut } from '../../../api/fetch';
import lov from "../../../reducers/lov";

const styles = (theme) => ({
  mainContent: {
    backgroundImage: ENV === TFI ? `url(${images.tfiSign})` : "none",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "1200px",
    boxShadow: "0px 0px 4px 0px " + colors.black23,
    borderRadius: "4px",
    backgroundColor: colors.white,
    margin: "0px 0px 30px 0px",
    //overflow: "auto",
    minHeight: "250px",
    paddingTop: "15px",
    paddingBottom: "25px",
  },
  cardContainer: {
    maxHeight: "350px",
    [theme.breakpoints.down("lg")]: {
      padding: "25px 15px",
      width: "33%",
      maxWidth: "310px",
    },
    [theme.breakpoints.up("lg")]: {
      padding: "25px 30px",
      width: "340px",
      maxWidth: "340px",
    },
  },
  card: {
    borderRadius: "4px",
    height: "100%",
    boxShadow: "0px 2px 20px 6px " + colors.black7,
    position: "relative",
    backgroundColor: colors.white,
  },
  noneCard: {
    paddingBottom: "0 !important",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
    "& img": {
      [theme.breakpoints.down("lg")]: {
        height: "80px",
      },
      [theme.breakpoints.up("lg")]: {
        height: "100px",
      },
    },
  },
  cardTitle: {
    textAlign: "center",
    height: "31px",
    lineHeight: "31px",
    fontWeight: "500",
    fontSize: "1.125em",
    borderRadius: "4px 4px 0px 0px",
  },
  cardImg: {
    padding: "0px",
    height: " 140px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  status: {
    minHeight: "22px",
    textAlign: "center",
    margin: "9px",
  },
  topBarTitle: {
    color: colors.black87,
    fontWeight: "500",
    marginRight: "10px",
  },
  detailField: {
    marginTop: "8px",
  },
  detailFieldTitle: {
    color: colors.black87,
    fontWeight: "500",
    marginRight: "5px",
  },
  tooltip: {
    marginTop: "5px",
    fontSize: "1em",
    padding: "8px 16px",
    fontWeight: "400",
  },
  actionButton: {},
  tagContainer: {
    display: "flex",
    alignItems: "center"   
  },
  dialogPaper: {
    padding: "12px",
    minWidth: "400px",
    maxWidth: "400px",
  },
  tagText: {
    color: "#5f00a0",
    cursor: "pointer",
    textDecoration: "underline"
  },
  closeIconItem: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
  },
});

const cards = [driver, truck, trailer, container];

class LiveEventsDriveInOut extends Component {
  mounted = false;
  initialized = false;

  constructor(props) {
    super(props);
    this.state = {
      displayDetails: "none",
      lov: {},
      isLiveAssistanceDialogueOpen: false,
      showOverrideType: "",
      contextPhotos: null,
      tags: [],
      selectedTagValue: {},
      selectedTag: null,
      tagType: null,
      tagError: null,
      open: false
    };
  }
  
  componentDidMount() {
    this.mounted = true;
    this.fetchLov();
  }

  componentWillUnmount() {
    this.mounted = false;
    
  }

  logPropModificationDetection = (log) => {
    let dacId;
    [container, trailer, driver, truck].forEach((type) => {
      const id = get(log, [type, "dacId"]);
      if (id) {
        dacId = id;
      }
    });
    return dacId;
  };

  componentDidUpdate(prevProps) {
    try {
      if(this.logPropModificationDetection(prevProps.log) !== this.logPropModificationDetection(this.props.log)) {
        this.setState({
          selectedTagValue: {},
          selectedTag: null,
          tagType: null,
          tagError: null
        })
      }
      // if(JSON.stringify(prevProps.log) !== JSON.stringify(this.props.log)) {
        
      // }
    } catch(error){}
  }

  shouldComponentUpdate(nextProps, nextState) {
    if(this.props !== nextProps) {
      return true
    }

    if(this.state !== nextState) {
      return true
    }
  }
  
  fetchLov = async () => {
    try {
      this.setState({
        lov: {
          89: await getLov(89),
          
        },
        tags: await getLov("tags"),
      });
    } catch (e) {
      console.log(e);
    }
  };
 
  renderTopBar = () => {
    return (
      <Grid
        container
        direction="column"
        alignItems="stretch"
        style={{ paddingLeft: "15px" }}
      >
        <Grid item >
          <Grid container>
            <Grid item style={{ minWidth: "350px" }}>
              <span className={this.props.classes.topBarTitle}>
                {I18n.get("site_startTime")}
              </span>
              <span className="text-54">
                {get(this.props.entries, [
                  truck,
                  "detectionEventGroup",
                  "start",
                ]) &&
                  formatDate(
                    get(this.props.entries, [
                      truck,
                      "detectionEventGroup",
                      "start",
                    ])
                  )}
              </span>
            </Grid>
            <Grid item style={{ minWidth: "200px" }}>
              <span className={this.props.classes.topBarTitle}>
                {I18n.get("site_elapsed")}
              </span>
              <Timer
                from={
                  new Date(
                    get(this.props.entries, [
                      truck,
                      "detectionEventGroup",
                      "start",
                    ])
                  ).getTime() || 0
                }
                freeze={this.props.entries.freezeTimer}
              />
            </Grid>
            <Grid item></Grid>
            <Grid item>
              <span className={this.props.classes.topBarTitle}>
                {I18n.get("site_currentState")}
              </span>
              <span
                className="text-87 bold-500"
                style={{
                  backgroundColor: colors.orange20,
                  display: "inline-block",
                  padding: "0px 13px",
                }}
              >
                {this.props.entries.globalState === 0 &&
                  I18n.get("site_noVehicleAtGate").toUpperCase()}
                {this.props.entries.globalState === 1 &&
                  I18n.get("site_vehicleAtGate").toUpperCase()}
              </span>
            </Grid>
            {this.props.entries.timer && (
              <Grid item style={{ paddingLeft: "30px" }}>
                <span className={this.props.classes.topBarTitle}>
                  {I18n.get("site_clearingIn")}
                </span>
                <CountDown duration={this.props.entries.timer} />
              </Grid>
            )}
            {this.getDetectionEventGroup() && (
              <ChangeDecisionDialog
                log={this.getDetectionEventGroup()}
                refreshLog={this.refreshDetectionEventGroup}
                style={{ paddingRight: "10px" }}
                section={this.props.section}
                hideRequireAssistanceButton={true}
                isLiveEventsDriveInOut={true}
                disableButtons={!!this.props.entries.timer}
              />
              
            )}
           
          </Grid>
        </Grid>
      </Grid>
    );
  };

  getDetectionEventGroup = () => {
    let detectionEventGroups;

    [container, trailer, driver, truck].forEach((type) => {
      const eventGroup = get(this.props.log, [type, "detectionEventGroup"]);
      if (eventGroup) {
        detectionEventGroups = eventGroup;
      }
    });
    return detectionEventGroups;
  };

  refreshDetectionEventGroup = async (id) => {
    try {
      this.props.dispatch(
        updateOneLog(
          this.props.section,
          this.props.tabIndex,
          null,
          id ? id : this.props.log.id
        )
      );
    } catch (e) {
      console.log(e);
    }
  };

  renderAbsentCard = (type, loading = false) => {
    return (
      <Grid item className={this.props.classes.noneCard}>
        <Grid container direction="column" alignItems="center">
          <Grid item>
            {loading ? (
              <img
                src={
                  type === driver
                    ? images.humanIcon
                    : type === truck
                    ? images.vehicleAnim
                    : type === trailer
                    ? images.trailerAnim
                    : type === container
                    ? images.containerIconGrey
                    : null
                }
                alt={type + "_icon"}
              />
            ) : (
              <img
                src={
                  type === driver
                    ? images.humanIcon
                    : type === truck
                    ? images.vehicleIcon
                    : type === trailer
                    ? images.trailerIcon
                    : type === container
                    ? images.containerIconGrey
                    : null
                }
                alt={type + "_icon"}
              />
            )}
          </Grid>
          {loading && (
            <>
              <Grid item style={{ margin: "10px 0px" }}>
                <CircularProgress size={15} />
                <span className="text-54" style={{ marginLeft: "10px" }}>
                  {I18n.get("site_activityDetected")}
                </span>
              </Grid>
            </>
          )}
        </Grid>
      </Grid>
    );
  };

  renderCardImage = (type) => {
    let contextPhoto = "";

    // Temporary LKC-376
    if (
      type === trailer &&
      size(get(this.props, ["entries", type, "detection", "ocr"])) > 0
    ) {
      contextPhoto = this.props.entries[type].detection.ocr[0].contextImage;
    }
    if (!contextPhoto) {
      if (
        size(get(this.props, ["entries", type, "detection", "contextPhotos"])) >
        0
      ) {
        contextPhoto = this.props.entries[type].detection.contextPhotos[0];
      } else {
        if (size(get(this.props, ["entries", type, "detection", "lpr"])) > 0) {
          contextPhoto = this.props.entries[type].detection.lpr[0].contextImage;
        } else if (
          size(get(this.props, ["entries", type, "detection", "ocr"])) > 0
        ) {
          contextPhoto = this.props.entries[type].detection.ocr[0].contextImage;
        } else if (
          size(get(this.props, ["entries", type, "detection", "fr"])) > 0
        ) {
          contextPhoto = this.props.entries[type].detection.fr[0].img;
        }
      }
    }
    if (!contextPhoto) {
      contextPhoto = get(this.props, [
        "entries",
        type,
        "detection",
        "capturedImages",
        0,
      ]);
    }
    return (
      <Grid item className={this.props.classes.cardImg}>
        <Box
          style={{
            height: "140px",
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "center",
          }}
        >
          <Picture
            url={contextPhoto}
            alt={type}
            maxHeight={140}
            style={{
              maxWidth: "100%",
              maxHeight: "140px",
            }}
            noLoadingBorder
          />
        </Box>
      </Grid>
    );
  };

  handleDisplayValue = (event, type = "", profile = "") => {
    if (type === "tag") {
      this.setState({
        tagType: profile,
        selectedTag: null,
        tagError: null
      });
    } else {
      event.preventDefault();
      event.stopPropagation();
    }
  };

  renderValue = (value, noShorten = false, type, profile = "") => {
    let displayValue = value;
    let shorten = false;
    let maxLength = type === "tag" ? 10 : 12;
    if (value && value.length > maxLength && !noShorten) {
      displayValue = value.substring(0, maxLength - 2) + "...";
      shorten = true;
    }

    if (shorten) {
      return (
        <Tooltip
          title={value}
          classes={{ tooltip: this.props.classes.tooltip }}
        >
          <span
            style={{ whiteSpace: "nowrap" }}
            onClick={(event) => this.handleDisplayValue(event, type, profile)}
            className={type === "tag" ? this.props.classes.tagText : "text-54"}
          >
            {displayValue}
          </span>
        </Tooltip>
      );
    }
    return (
      <span
        onClick={(event) => this.handleDisplayValue(event, type, profile)}
        className={type === "tag" ? this.props.classes.tagText : "text-54"}
        style={{ whiteSpace: "nowrap" }}
      >
        {displayValue}
      </span>
    );
  };

  handleTagSelectorChange = async (value, type) => {
    try {
      const profileID = this.props.log?.[type]?.profile?.id;
      
      if (profileID && value) {
        await fetchPut(`profiles/${profileID}`, { sys_tag_id: value });
        this.setState({
          tagType: null,
          tagError: "",
          selectedTagValue: {
            ...this.state.selectedTagValue,
            [type]: value,
          },
        })
      } else {
        this.setState({
          tagError: !profileID ? 'Tag is not saved' : !value ? 'Tag is required' : ""
        })
      }
    } catch(error) {
      this.setState({
        tagError: 'Tag is not submitted'
      })
    }
  };

  renderCardDetails = (type) => {
    let profile = get(this.props.entries, [
      type,
      "detectionEventGroup",
      "profile",
    ]);

    let profileConfidence = get(this.props.entries, [
      type,
      "profile",
      "confidence",
    ]);

    let ocrNb = 0;
    let ocrs = [];
    if (type !== driver) {
      ocrs = getAttributeValues(profile, 50);
      ocrs = ocrs.filter((item) => item.value !== null);
      ocrNb = ocrs.length;
    }
    const selectedTag = this.state.tags.find((tag) => {
      const value = this.state.selectedTagValue[type] ? this.state.selectedTagValue[type] : get(profile, [`tag_id`]);
      return tag.id === value;
    });
   
    const tagValue = selectedTag
    ? selectedTag[`name_${this.props.language}`]
    : get(profile, [
        "tag",
        `name_${this.props.language}`
      ])
    return (
      <Grid item>
        <Grid container direction="column">
          <Grid item className={this.props.classes.detailField}>
            <Grid container>
              <Grid item className={this.props.classes.detailFieldTitle}>
                {I18n.get("site_profile")}:
              </Grid>
              <Grid item style={{ marginRight: "5px" }}>
                <Link
                  to={`/profiles/${get(profile, ["id"])}`}
                  style={{ color: colors.primary, fontSize: "inherit" }}
                >
                  <span>{get(profile, ["name"])}</span>
                </Link>
              </Grid>
              <Grid item className="text-54">
                {profileConfidence ? `(${parseInt(profileConfidence * 100)}%)` :""}
              </Grid>
              {get(this.props, [
                "entries",
                type,
                "detectionEventGroup",
                "profile",
                "tag",
                "threat_flag",
              ]) && (
                <Grid item style={{ marginLeft: "5px", height: "20px" }}>
                  <img
                    src={images.threatFlag}
                    height="16px"
                    alt="threat_flag"
                  />
                </Grid>
              )}
            </Grid>
            <Grid item className={this.props.classes.detailField}>
              <Grid container>
                <Grid item xs={6}>
                  <Grid
                    container
                    wrap="nowrap"
                    className={this.props.classes.tagContainer}
                  >
                    <Grid item className={this.props.classes.detailFieldTitle}>
                      {I18n.get("site_tag2")}:
                    </Grid>
                    <Grid item>
                      <TagColor
                        // color={`#${get(profile, ["tag", "color_rgb"])}`}
                          color={`#${selectedTag?.color?.rgb}`}
                      />
                    </Grid>
                    <Grid item>
                      {this.renderValue(
                        tagValue ? tagValue : "No tag assigned",
                        type !== driver ? false : true,
                        "tag",
                        type
                      )}
                    </Grid>
                  </Grid>
                </Grid>
                {type !== driver && (
                  <Grid item xs={6}>
                    <Grid container wrap="nowrap">
                      <Grid
                        item
                        className={this.props.classes.detailFieldTitle}
                      >
                        {I18n.get("site_carrier2")}:
                      </Grid>
                      <Grid item>
                        {this.renderValue(
                          getAttributeValue(
                            profile,
                            89,
                            this.state.lov,
                            this.props.language
                          )
                        )}
                      </Grid>
                    </Grid>
                  </Grid>
                )}
              </Grid>
            </Grid>
            <Grid item className={this.props.classes.detailField}>
              {type !== driver && (
                <Grid container>
                  <Grid item xs={6}>
                    <Grid container wrap="nowrap">
                      <Grid
                        item
                        className={this.props.classes.detailFieldTitle}
                      >
                        {I18n.get("site_lpr")}:
                      </Grid>
                      <Grid item>
                        {this.renderValue(getAttributeValue(profile, 44))}
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={6}>
                    <Grid container wrap="nowrap">
                      <Grid
                        item
                        className={this.props.classes.detailFieldTitle}
                      >
                        {I18n.get("site_ocr")}:
                      </Grid>
                      <Grid item className="text-54">
                        {ocrNb === 0 ? (
                          <span>--</span>
                        ) : (
                          <Tooltip
                            title={
                              <React.Fragment>
                                {ocrs
                                  .sort((a, b) => (b.mandatory_match ? 1 : -1))
                                  .map((item, index) => (
                                    <Box
                                      key={index}
                                      style={{ margin: "8px 0px" }}
                                    >
                                      <span
                                        style={{
                                          display: "inline-block",
                                          width: "18px",
                                        }}
                                      >
                                        {item.mandatory_match && (
                                          <img
                                            src={images.checkmarkWhite}
                                            alt="checkmark"
                                            height="10px"
                                          />
                                        )}
                                      </span>
                                      {item.value}
                                    </Box>
                                  ))}
                              </React.Fragment>
                            }
                            classes={{ tooltip: this.props.classes.tooltip }}
                          >
                            <span>{`(${ocrNb})...`}</span>
                          </Tooltip>
                        )}
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              )}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    );
  };

  renderTagModal = () => {
    const { classes, entries, language } = this.props;
    const { tagType, selectedTag, tags, selectedTagValue } = this.state;
    let profile = get(entries, [
      tagType,
      "detectionEventGroup",
      "profile",
    ]);
    return (
      <Dialog
        open={!!tagType}
        classes={{ paper: classes.dialogPaper }}
      >
        <Grid container direction="column">
          <Grid item>
            <Grid container alignItems="center">
              <Grid item xs={12} className={classes.closeIconItem}>
                <CloseIcon closeFunction={() => this.setState({tagType: null})} />
              </Grid>
            </Grid>
          </Grid>
          <Grid item style={{ padding: "12px" }}>
            <Grid item>
              <FormSection
                formValue={
                  tagType && selectedTag
                    ? [selectedTag]
                    : selectedTagValue[tagType] ? [selectedTagValue[tagType]] : [get(profile, [`tag_id`])]
                }
                setFormValue={(id, index, value) => this.setState({selectedTag: value})}
                title="tag"
                id="sys_tag_id"
                type="select"
                options={{
                  required: false,
                  comboBox: true,
                  options:
                    tags?.length &&
                    tags.map((t) => ({
                      id: t.id,
                      name: t["name_" + language],
                    })),
                }}
              />
            </Grid>
            <Grid item>
              <p style={{color: "red"}}>{this.state.tagError}</p>
            </Grid>
            <Grid item>
              <Grid container justify="center" style={{ marginTop: "40px" }}>
                <Grid item>
                  <CustomButton color="primary" onClick={() => this.setState({tagType: null})}>
                    {I18n.get("site_cancel")}
                  </CustomButton>
                </Grid>
                <Grid item style={{ marginLeft: "10px" }}>
                  <CustomButton
                    variant="contained"
                    color="primary"
                    onClick={()=> this.handleTagSelectorChange(selectedTag,tagType)}
                  >
                    {I18n.get("site_apply")}
                  </CustomButton>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Dialog>
    );
  };

  renderUnknown = (type) => {
    return (
      <Grid container style={{ padding: "0px 20px", height: "100px" }}>
        <Grid
          item
          xs
          className="flexCenter"
          style={{ justifyContent: "center" }}
        >
          <img
            style={{ maxWidth: "100px", maxHeight: "60px" }}
            src={
              type === driver
                ? images.unknownDriver
                : type === truck
                ? images.unknownTruck
                : type === trailer
                ? images.unknownTrailer
                : type === container
                ? images.containerUnknown
                : null
            }
            alt="unknown"
          />
        </Grid>
        <Grid
          item
          className="flexCenter text-54"
          style={{
            width: "90px",
            fontSize: "1.2em",
          }}
        >
          {I18n.get("site_unknown")}
        </Grid>
      </Grid>
    );
  };
  handleProfileCreated = (type, profile, note = null) => {
    this.props.dispatch(
      updateOneLog(
        this.props.section,
        this.props.tabIndex,
        this.props.openFromTab,
        this.props.log.id
      )
    );
  };
  getProfileProps = (type) => {
    let log = this.props.log[type]?.detectionEventGroup;
    let details = {
      dacId: this.props.log[type]?.dacId,
      dacEventGroup: this.props.log[type]?.detectionEventGroup,
      detectionId: this.props.log[type]?.detectionEventGroup?.id || "",
      detectionEventGroup: this.props.log[type]?.detectionEventGroup || null,
      log,
      lov: this.state.lov,
      handleProfileOverride: this.handleProfileCreated,
      contextPhotos: this.props.log[type]?.detection?.contextPhotos || [],
      ocr: this.props.log[type]?.detection?.ocr || [],
      lpr: this.props.log[type]?.detection?.lpr || [],
      fr: this.props.log[type]?.detection?.fr || [],
      lukeIndex: get(this.props, ["log", "detections", type, "luke_index"]),
      override: get(this.state, ["overrides", type]),
    };

    return details;
  };

  renderStatus = (type) => {
    return (
      <Grid
        item
        className={`flexCenter ${this.props.classes.status}`}
        style={{ justifyContent: "space-around" }}
      >
        <div>
          <span className="text-87 bold-500" style={{ marginRight: "5px" }}>
            {I18n.get("site_status")}
          </span>
          <span className="text-54">
            {get(this.props.entries, [
              type,
              "detectionEventGroup",
              "status",
              `name_${this.props.language}`,
            ])}
          </span>
        </div>
        <div style={{ display:"flex",justifyContent: "space-around" , alignItems:"center"}}>
          {[truck, trailer, container].includes(type) && (
            <CustomButton
              variant="contained"
              color="primary"
              style={{ color: colors.white, padding:"0px",minWidth:"fit-content" }}
              onClick={() => {
                let newPhoto = [];
                const photos = get(this.props, [
                  "log",
                  type,
                  "detection",
                  "contextPhotos",
                ])
                  ? get(this.props, ["log", type, "detection", "contextPhotos"])
                  : [];

                photos.forEach((img) => {
                  const response = getOcrLprConfirmationCorrection(
                    {
                      url: img,
                      type: CONTEXT,
                      values: [],
                      matched: true,
                    },
                    get(this.props.log, [type, "detectionEventGroup"])
                  );
                  newPhoto.push(response);
                });

                this.setState({
                  showOverrideType: type,
                  contextPhotos: newPhoto,
                });
              }}
            >
              <OverrideIcon height="36" width="36" />
            </CustomButton>
          )}
          {[driver].includes(type) && (
            <FrResults
              open={this.state.showOverrideType === driver}
              onOpen={() =>
                this.setState({
                  showOverrideType: driver,
                })
              }
              onClose={() =>
                this.setState({
                  showOverrideType: "",
                })
              }
              section={this.props.section}
              event={this.getProfileProps(type)}
              overriden={
                get(this.props.log, ["overriden"]) ? this.props.log : null
              }
              dacEventGroup={this.getProfileProps(type)?.["dacEventGroup"]}
              onlyOverride={true}
              triggerNode={
                <CustomButton
                  variant="contained"
                  color="primary"
                  style={{ color: colors.white, padding:"0px",minWidth:"fit-content" }}
                >
                  <OverrideIcon height="36" width="36" />
                </CustomButton>
              }
              tabs={this.props.tabs}
              log={this.props.log}
              isLive={true}
              liveEventCardType={type}
              liveZoneId={this.props.zone.id}
            />
          )}
               <CustomButton
              style={{ marginLeft:"20px",padding:"0px",minWidth:"fit-content" }}
                onClick={() => this.setState({open:true})}
                startIcon={<img src={images.removeIcon} />}
              />
              <MessageDialog
                open={this.state.open}
                message={I18n.get("profile_remove")}
                isEvent={true}
                onClose={async (flag) => {
                  if (flag) {
                    let eventGroupId = get(this.props.entries, [
                      type,
                      "event_group_id",
                    ]);
                    await fetchPut(`event_groups/${eventGroupId}`, {
                      active: false,
                      source: "live",
                    });
                  }
                  this.setState({open:false})
                }}
              /> 
        </div>
      </Grid>
    );
  };

  renderDetectionDetails = () => {
    if (this.props.entries[this.state.displayDetails].detection) {
      return (
        <Box
          className={this.props.classes.mainContent}
          style={{ backgroundImage: "none" }}
        >
          {this.state.displayDetails !== driver ? (
            <DetectionDetailsNew
              type={this.state.displayDetails}
              details={this.props.entries[this.state.displayDetails]}
              handleProfileCreated={this.handleProfileCreated}
              close={() => this.setState({ displayDetails: "none" })}
              language={this.props.language}
              zoneId={this.props.zone.id}
            />
          ) : (
            <DetectionDetails
              close={() => this.setState({ displayDetails: "none" })}
              capturedImages={
                this.props.entries[this.state.displayDetails].detection
                  .capturedImages
              }
              matchedProfile={
                this.props.entries[this.state.displayDetails].detection
                  .matchedProfile
              }
              fr={this.props.entries[this.state.displayDetails].detection.fr}
              lpr={this.props.entries[this.state.displayDetails].detection.lpr}
              ocr={this.props.entries[this.state.displayDetails].detection.ocr}
              type={this.state.displayDetails}
              state={this.props.entries[this.state.displayDetails].state}
              handleProfileCreated={this.handleProfileCreated}
              language={this.props.language}
            />
          )}
        </Box>
      );
    }
    return <></>;
  };

  render() {
    return (
      <>
        <Box className={this.props.classes.mainContent}>
          {this.renderTopBar()}
          <Grid
            container
            alignItems="stretch"
            justify="center"
            style={{
              height: this.props.powerUserModeEnabled ? "380px" : "350px",
              // maxHeight: this.props.powerUserModeEnabled ? "380px" : "350px",
            }}
          >
            {cards.map((type) => (
              <Grid
                item
                key={type}
                className={this.props.classes.cardContainer}
              >
                <>
                  {this.props.entries[type] && (
                    <Grid
                      container
                      wrap="nowrap"
                      direction="column"
                      className={this.props.classes.card}
                    >
                      <Grid
                        item
                        className={this.props.classes.cardTitle}
                        style={{
                          backgroundColor: get(this.props, [
                            "entries",
                            type,
                            "detectionEventGroup",
                            "profile",
                            "tag",
                            "threat_flag",
                          ])
                            ? `#${get(this.props, [
                                "entries",
                                type,
                                "detectionEventGroup",
                                "profile",
                                "tag",
                                "color_rgb",
                              ])}`
                            : colors.cardTitleBg,
                          color: getTextColor(
                            get(this.props, [
                              "entries",
                              type,
                              "detectionEventGroup",
                              "profile",
                              "tag",
                              "threat_flag",
                            ])
                              ? `#${get(this.props, [
                                  "entries",
                                  type,
                                  "detectionEventGroup",
                                  "profile",
                                  "tag",
                                  "color_rgb",
                                ])}`
                              : colors.cardTitleBg
                          ),
                        }}
                      >
                        {I18n.get("site_" + type)}
                      </Grid>
                      <Grid item xs>
                        <Grid
                          container
                          direction="column"
                          style={{ height: "100%", padding: "0px 8px" }}
                        >
                          {this.props.entries[type].loading ||
                          (this.props.entries[type].state === identified &&
                            !this.props.entries[type].detectionEventGroup) ||
                          this.props.entries[type].state === absent ? (
                            <>
                              {this.renderAbsentCard(type)}
                              {/* {this.renderCardDetails(type)} */}
                            </>
                          ) : (
                            <>
                              {this.renderStatus(type)}
                              {this.renderCardImage(type)}
                              {this.props.entries[type].state === identified
                                ? this.renderCardDetails(type)
                                : this.renderUnknown(type)}
                            </>
                          )}
                        </Grid>
                      </Grid>
                      {this.props.powerUserModeEnabled && (
                        <Grid item className="text-center">
                          <Button
                            color="primary"
                            size="small"
                            //disabled={!detailsEnabled}
                            onClick={() =>
                              this.setState({ displayDetails: type })
                            }
                          >
                            {I18n.get("site_details")}
                          </Button>
                        </Grid>
                      )}
                    </Grid>
                  )}
                </>
              </Grid>
            ))}
          </Grid>
        </Box>
        {this.state.displayDetails !== "none" && this.renderDetectionDetails()}
        {[truck, trailer, container].includes(this.state.showOverrideType) &&
          this.state.contextPhotos && (
            <CorrectConfirmValue
              section={this.props.section}
              open={this.state.contextPhotos !== null}
              initialValue={this.state.contextPhotos?.[0]}
              close={() =>
                this.setState({
                  contextPhotos: null,
                })
              }
              photos={this.state.contextPhotos}
              profileType={this.state.showOverrideType === truck ? 2 : 3}
              profile={get(this.props.log, [
                this.state.showOverrideType,
                "detectionEventGroup",
                "profile",
              ])}
              detectionEventGroup={
                this.getProfileProps(this.state.showOverrideType)
                  .detectionEventGroup
              }
              refreshDetectionEventGroup={this.refreshDetectionEventGroup}
              reloadEventGroupAndFocusElement={this.refreshDetectionEventGroup}
              dacId={this.getProfileProps(this.state.showOverrideType).dacId}
              tabs={this.props.tabs}
              liveEventCardType={this.state.showOverrideType}
              liveZoneId={this.props.zone.id}
            />
          )}
        {this.state.tagType && this.renderTagModal()}
      </>
    );
  }
}

LiveEventsDriveInOut.propTypes = {
  zone: PropTypes.object.isRequired,
  log: PropTypes.object.isRequired,
  tab: PropTypes.object.isRequired,
  entries: PropTypes.shape({
    globalState: PropTypes.number,
    startTime: PropTypes.number,
    driver: PropTypes.object,
    truck: PropTypes.object,
    trailer: PropTypes.object,
    container: PropTypes.object,
    displayDetails: PropTypes.string,
  }).isRequired,
};

const mapStateToProps = (state) => {
  return {
    language: state.user.language,
    powerUserModeEnabled: state.common.powerUserModeEnabled,
  };
};

export default connect(mapStateToProps)(
  withStyles(styles)(LiveEventsDriveInOut)
);
